import { Component, OnInit } from '@angular/core'

@Component({
    selector: './damsnt-faq',
    templateUrl: './damsnt-faq.component.html',
    styleUrls: ['../../../../../help.component.css']
})

export class DamsNTFAQComponent implements OnInit {

    ngOnInit() {

    }
}